import { Input } from "../ui/input";

type Props = {
  search: string;
  setSearch: (value: string) => void;
}

export default function TableSearch({ search, setSearch }: Props) {

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  return (
    <Input
      placeholder="Filter"
      value={search}
      onChange={handleSearch}
      className="max-w-sm"
    />
  )
}
